import { render } from "./Cookies.vue?vue&type=template&id=a23a4de8&scoped=true"
import script from "./Cookies.vue?vue&type=script&lang=js"
export * from "./Cookies.vue?vue&type=script&lang=js"

import "./Cookies.vue?vue&type=style&index=0&id=a23a4de8&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a23a4de8"]])

export default __exports__